import React from 'react';
import { useSelector } from 'react-redux';
import { labelsSelector } from 'src/redux/app/selectors';

const factoryDefault = val => val;

const Label = ({ name, fallback, factory = factoryDefault }) => {
  const labels = useSelector(labelsSelector);

  return <>{factory(labels[name] || fallback || name)}</>;
};

export default Label;
